<div class="container-morfeo" >
    <div class="row" *ngIf="showTable" style="justify-content: center;">
      <div class="col-sm-12">
        <!-- <mat-card class="planbox" style="margin-top: 3rem; width: fit-content;">  -->
        <mat-card class="planbox" style="margin-top: 3rem;"> 
          <mat-card-title class="title-panel" style="display: flex;">
       
            <div >
              <h1> Transacciones ilocalizables</h1>

            </div>

          </mat-card-title>

          <div class="row" style="margin-top: 15px; margin-bottom:20px">
            <div class="col-6" style="margin-left: 15px; display: flex;">
              <button type="button" class="btn btn-light btn primary-btn" (click)="clickShowCreate()" style="margin-right: 20px;">
                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                Crear Transacción Temporal
              </button>

              <button type="button" class="btn btn-light btn primary-btn" (click)="showFilter()" style="margin-right: 10px;">
                <i class="fa fa-filter" aria-hidden="true"></i>
                Filtros
              </button>
            </div>

            <div class="col-6" style="margin-left: auto; display: flex;   justify-content: end;">

            
            </div>
          </div>

          <mat-card-content>
            <table aria-label="idtable" class="table table-condensed table-striped">
              <!-- <table class="table-condensed table-hover full-width"> -->
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Fecha de creación</th>
                    <th scope="col">Usuario</th>
                    <th scope="col">Tipo de transacción</th>
                    <th scope="col">Cliente</th>
                    <th scope="col">Estado</th>
                   
                    <th scope="col" style="text-align: center;">Severidad</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let t of temporalTransactions">
                    <th scope="row">{{t.id}}</th>
                    <td>{{t.creation_date}}</td>
                    <td>{{t.username}}</td>
                    <td>{{t.type_management_name}}</td>
                    <td >{{t.customer_name}}</td>
                    <td style="color: crimson;" *ngIf="t.status==10">Pendiente</td>
                    <td style="color: darkgreen;" *ngIf="t.status==20">Completada</td>
                   
                   
                    <td style="text-align: center;"><span class="{{getSeverityClass(t.priority)}}"></span></td>
                
                    <td><button class="btn btn-light btn primary-btn" (click)="getInfo(t)">Detalle</button></td>
                    <td *ngIf="t.close_date">{{t.close_date}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- <mat-paginator 
                [length]="totalTransactions"
                [pageSize]="perPage"                  
                [hidePageSize] = "true"
                [showFirstLastButtons] = "true"
                (page)="pageEvent= changePage($event);">
              </mat-paginator>  -->

          
          
          </mat-card-content>
       
        </mat-card>
        <div class="inline-paginator text-center w-100 mb-2">
          <p-paginator
            [rows]="perPage" [totalRecords]="totalTransactions"
            (onPageChange)="nextPage($event)">
          </p-paginator>
        </div>
      </div>
    </div>



    <!-- Vista de detalle de gestión-->
    <div class="row" *ngIf="showDetail">

      <div class="col-sm-12">
        <mat-card class="planbox" style="margin-top: 3rem;"> 
          <mat-card-title class="title-panel" style="display: flex;">
            <i class="fas fa-chevron-left" aria-hidden="true" (click)="clickShowTable()" style="margin-right: 1.2rem; cursor: pointer;"></i>
            <div >
              Detalle de transacción No. {{selectedTransaction.id}}
            </div>
          </mat-card-title>
          <mat-card-content>
            <div class="table-responsive" style="color: #545454;">
              <table aria-label="nodatatable" class="table table-borderless" style="color: #545454 !important;">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Fecha de solicitud:</th>
                    <td>{{selectedTransaction.creation_date}}</td>
                    <th scope="row">Tipo de gestión:</th>
                    <td>{{selectedTransaction.type_management_name}}</td>
                  </tr>

                  <tr *ngIf="selectedTransaction.type_management==3">
                    <th scope="row">Sub tipo gestión:</th>
                    <td>{{selectedTransaction.subtype_management_name}}</td>
                    <th scope="row">Detalle cancelación:</th>
                    <td>{{selectedTransaction.subtype2_management_name}}</td>
                  </tr>

                  <tr *ngIf="selectedTransaction.type_management !=3 && selectedTransaction.type_management !=6 ">
                    <th scope="row">Sub tipo gestión:</th>
                    <td>{{selectedTransaction.subtype_management_name}}</td>
                 
                  </tr>

                  <tr>
                    <th scope="row">Id del cliente</th>
                    <td>{{selectedTransaction.payload.customer_id}}</td>
                    <th scope="row">Nombre del cliente:</th>
                    <td>{{selectedTransaction.customer_name}}</td>
              
                  </tr>
                  <tr>
                   
                    <th scope="row">Teléfono:</th>
                    <td>{{selectedTransaction.customer_phone}}</td>
                  </tr>
                  <tr>
                    <th scope="row">País:</th>
                    <td>{{selectedTransaction.country_name}}</td>
                    <th scope="row">Sponsor</th>
                    <!-- <td>{{selectedTransaction.sponsor_name}} ( {{selectedTransaction.sponsor_id}} )</td> -->
                    <td> {{selectedTransaction.sponsor_name}}</td>
              
                  </tr>
                  <tr>
                    <th scope="row">Producto:</th>
                    <td>{{selectedTransaction.product_name}}</td>
                    <th scope="row">Código de asistencia:</th>
                    <td>{{selectedTransaction.payload.assistance_code}}</td>
              
                  </tr>
                 
                
                  <!-- <tr>
                    <th scope="row">Tipología:</th>
                    <td colspan="3">{{selectedTransaction.typologyDesc}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Subtipología:</th>
                    <td colspan="3">{{selectedTransaction.subtypologyDesc}}</td>
                  </tr> -->
                  <tr>
                    <th scope="row">Canal de venta:</th>
                    <!--1 = Telemercadeo
                        2 = Surcursales
                        3 = Digital
                        4 = Otro-->
                    <td *ngIf="selectedTransaction.sales_channel_id == 1">Telemercadeo</td>
                    <td *ngIf="selectedTransaction.sales_channel_id== 2">Surcursales</td>
                    <td *ngIf="selectedTransaction.sales_channel_id == 3">Digital</td>
                    <td *ngIf="selectedTransaction.sales_channel_id == 4">Otro</td>
                    <th scope="row">Estado</th>
                    <td>
                      <strong>{{selectedTransaction.status==20? 'Completada' : 'Pendiente'}}</strong>
                   
                    </td>
<!-- 
                    <th>Severidad:</th>
                    <td>{{selectedTransaction.status==20? 'Completada' : 'Pendiente'}}</td> -->
                  </tr>

                  <tr>
                    <th scope="row">Severidad</th>
                    <td>
                   
                      <button *ngIf="selectedTransaction.priority==30" type="button" class="btn btn-danger ml-2 bold" >Urgente</button>
                      <button *ngIf="selectedTransaction.priority==20"  type="button" class="btn btn-warning ml-2 bold" >Intermedio</button>
                      <button *ngIf="selectedTransaction.priority==10" type="button" class="btn btn-success ml-2 bold">Normal</button>

                    </td>

                    <th scope="row">Comentario:</th>
                    <td colspan="3">{{selectedTransaction.comment}}</td>
                  </tr>
                </tbody> 
              </table>
              <hr class="solid">
           
            </div>
            <div class="detailBtn">
              <button type="button" class="btn secundary-btn secundary-btn-fw" (click)="clickShowTable()">Regresar</button>
              <button  *ngIf="selectedTransaction.status!=20" type="button" data-toggle="modal" data-target="#closeModal"  (click)="showCloseForm()" class="btn btn-light btn primary-btn">Cerrar Gestión</button>
            </div>
            </mat-card-content>
        </mat-card>
      </div>
    
    </div>


    <!-- vista crear transaccion temporal -->
    <div class="row" *ngIf="showCreate">

      <div class="container-fluid">
   
          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-container">
                  <div class="title-panel">
                    <img alt="" style="margin-top: 3px;" (click)="clickShowTable()" class="go-to-back-title"  [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">
                    <h1 style="margin-left: 17px;">
                     Crear Transacción Temporal
                    </h1>
    
                  </div>
    
                  <div class="p-4">
                    <app-create-temporal-transaction (done)="clickShowTable2()"  (cancelEvent)="clickShowTable()"></app-create-temporal-transaction>
                  </div>
    
                </div>
              </div>
            </div>
          </div>
       
      </div>

    
    </div>

  </div>
  


    <!-- modal de cierre de ticket -->
    <p-dialog [(visible)]="showCloseTicketForm" [responsive]="true"
    [modal]="true" [draggable]="false" [breakpoint]="600"
    [class.ui-dialog-titlebar]="true" [blockScroll]="true" [style]="{width: '30vw', height:'32vh'}" width="300" height="200">
  <ng-template pTemplate="header">
    {{ 'Cerrar caso' | translate }}
  </ng-template>


    
    <div class="modal-body">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 ml-auto control-label">
            <label>Comentario:</label>
          </div>
      

        
        </div>

        <div class="row">
          <div class="col-md-12 ml-auto mb-3">
            <textarea class="form-control" placeholder="" [(ngModel)]="closeTransactionComment" name="close"> </textarea>
          </div>

        </div> 
      </div>  
    </div>  


    <p-footer>
        
      <button type="button" (click)="closeTransaction()" class="btn btn-light btn primary-btn" data-dismiss="modal">Cerrar Gestión</button>

    <div class="row">
      <div class="col-md-12 ml-auto">
        <p style="color: red;" id="labelError"></p>
      </div>
    </div>  
    </p-footer>

    </p-dialog>

<!-- vista filtro -->
  <p-dialog
  [(visible)]="showDialogFilter" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="600"
  [class.ui-dialog-titlebar]="true" [blockScroll]="true" [style]="{width: '45vw', height:'83vh'}" width="300" height="200">
  <ng-template pTemplate="header">
    {{ 'Filters' | translate }}
  </ng-template>
  
    <div class="modal-body">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 ml-auto control-label"><strong>Usuario gestor</strong></div>
          <div class="col-md-6 ml-auto control-label"><strong>Severidad</strong></div>
        </div>
        <div class="row">
          <div *ngIf="iAm(['admin,assistance_admin'])"  class="form-group col-sm-6">
            <select [(ngModel)]="filter.transactionUser" name="selectUser" class="form-control">
              <option [ngValue]= "undefined" selected >----------Seleccione----------</option>
              <option *ngFor="let user of crmUsers" [value]="user.id">{{user.name}} ({{user.email}})</option>
            </select>
          </div>

          <div class="form-group col-sm-6">
            <div class="col-sm-3" style="display: flex; align-items: center;justify-content: center; width: 25%;margin-left: 90px;">
              <div id="traffic-light" >
                <button type="button" class="{{getclass1(30)}}" (click)="setRed()">Urgente</button>
                <button type="button" class="{{getclass2(20)}}" (click)="setYellow()">Intermedio</button>
                <button type="button" class="{{getclass3(10)}}" (click)="setGreen()">Normal</button>
              </div> 
            </div>
          </div>
        </div><br>
        <div class="row">
          <div class="col-md-12 ml-auto control-label mb-3">
            <strong>Rango de fechas</strong>              
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 ml-auto control-label "><strong>Desde</strong></div>
          <div class="col-md-6 ml-auto control-label"><strong>Hasta</strong></div>
        </div>
        <div class="row">
          <div class="col-md-6 ml-auto main-container">
            
              <p-datepicker dateFormat="dd/mm/yy"  [(ngModel)]="filter.fromDate" [showIcon]="false" inputId="icon"></p-datepicker>
           
          </div>
          <div class="col-md-6 ml-auto main-container">
        
              <p-datepicker dateFormat="dd/mm/yy" [(ngModel)]="filter.toDate" [showIcon]="false" inputId="icon"></p-datepicker>
           
          </div>
        </div><br>
        <div class="row">
          <div class="col-md-6 ml-auto control-label"><strong>Severidad</strong></div>
        </div>
        <div class="row">
        
        </div><br>
        <div class="row">
          <div class="col-md-6 ml-auto control-label"><strong>Id. Transacción</strong></div>
          <div class="col-md-6 ml-auto control-label"><strong>Estado</strong></div>
        </div>
        <div class="row">
          <div class="col-md-6 ml-auto">
            <input type="text" min="0" class="form-control" placeholder="" [(ngModel)]="filter.transactionId">
          </div>
          <div class="form-group col-sm-6">
            <select [(ngModel)]="filter.v_status" name="seelctv_status" class="form-control">
              <option [ngValue]= "undefined"  selected>----------Seleccione----------</option>
              <option [ngValue]="10">Pendiente</option>
              <option [ngValue]="20">Completada</option>
            </select>
          </div>
        </div><br>
        
        <hr class="solid">
        <h5>
          Ordenamientos
        </h5><br>
        <div class="row">
          <div class="col-md-6 ml-auto control-label"><strong>Ordenar por</strong></div>
          <div class="col-md-6 ml-auto control-label"><strong>Ascendente/Descendente</strong></div>
        </div>
        <div class="row">
          <div class="col-md-6 ml-auto input-sm">
            <select [(ngModel)]="filter.orderBy" class="form-control">
              <option [ngValue]= "null">----------Seleccione----------</option>
              <option value="user">Usuario</option>
              <option value="date">Fecha</option>
              <option value="priority">Severidad</option>
              <option value="state">Estado</option>
              <option value="id">No. Gestion</option>
            </select>
          </div>
          <div class="col-md-6 ml-auto input-sm">
            <select [(ngModel)]="filter.order" class="form-control">
              <option [ngValue]= "null" >----------Seleccione----------</option>
              <option value="asc">Ascendente</option>
              <option value="desc">Descendente</option>
            </select>
          </div>
        </div><br>
      </div>
    </div>
    <p-footer> <button type="button" (click)="applyFilters()" class="btn btn-light btn primary-btn" data-dismiss="modal">Filtrar</button>
      <button type="button" class="btn btn-light btn secondary-btn"  data-dismiss="modal" (click)="hideFilter()">Cerrar</button> </p-footer>
 
      <!-- </div>
    </div>
  </div> -->
  </p-dialog>
  
<!-- 

    <div class="modal" tabindex="-1" role="dialog" id="closeModal">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="font-weight: bold; color: #545454;">Cerrar transacción</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">       
            <div class="row">
              <div class="col-md-12 ml-auto">
                <label>Comentario:</label>
              </div>
              <div class="col-md-12 ml-auto ">
                <textarea class="form-control" placeholder="GES-100 / SAC-100" [(ngModel)]="closeTransactionComment"> </textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 ml-auto">
                <p style="color: red;" id="labelError"></p>
              </div>
            </div>           
          </div>
          <div class="modal-footer">
            <button type="button" (click)="closeTransaction()" class="btn btn-primary" data-dismiss="modal">Cerrar Gestion</button>
            <button type="button" class="btn btn-secondary" (click)="closeModal()" data-dismiss="modal">Cancelar</button> 
          </div>
        </div>
      </div>
    </div> -->
